/**
 * Replace en element with a spinner
 * @param {String} element
 */
export const addNodeSpinner = (element) => {
  const elementRef = element;
  elementRef.innerHTML = '<div class="loading"></div>';
};
